import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "next-module-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.87408 3.81342C6.58119 3.52053 6.10631 3.52053 5.81342 3.81342C5.52053 4.10631 5.52053 4.58119 5.81342 4.87408L12.8456 11.9062L5.81342 18.9384C5.52053 19.2313 5.52053 19.7062 5.81342 19.9991C6.10631 20.292 6.58119 20.292 6.87408 19.9991L14.4366 12.4366C14.7295 12.1437 14.7295 11.6688 14.4366 11.3759L6.87408 3.81342Z" }, null, -1),
    _createElementVNode("path", { d: "M19.9062 4.46875C19.9062 4.05454 19.5705 3.71875 19.1562 3.71875C18.742 3.71875 18.4062 4.05454 18.4062 4.46875V19.6562C18.4062 20.0705 18.742 20.4062 19.1562 20.4062C19.5705 20.4062 19.9062 20.0705 19.9062 19.6562V4.46875Z" }, null, -1)
  ])))
}
export default { render: render }